module.exports = __webpack_public_path__ + "img/140.5b417f92.jpg";